jQuery(document).ready(function($) {
    let bp = BiggerPicture({
        target: document.body,
    });

    $('.trigger-carousel-lightbox').on('click', function(e) {
        bp.open({
            items: document.querySelectorAll('.gallery-carousel .glide__slide:not(.glide__slide--clone) img'),
            el: e.currentTarget
        })
    });

    $('.trigger-lightbox-white').on('click', function() {
        bp.open({
            items: $(this).parent().find('img'),
            onOpen: (container) => container.classList.add('white'),
        });
    });

    // Menu Toggle Functionality - with delay to ensure DOM is ready
    setTimeout(function() {
        // Remove any existing event handlers first
        $('.menutoggle').off('click');
        
        // Function to close the menu
        function closeMenu() {
            $('.menutoggle').removeClass('open');
            $('.site-header__nav .nav-menu').removeClass('open');
            $('body').removeClass('nav-open');
        }

        // Function to open the menu
        function openMenu() {
            $('.menutoggle').addClass('open');
            $('.site-header__nav .nav-menu').addClass('open');
            $('body').addClass('nav-open');
        }

        $('.menutoggle').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            var $button = $(this);
            
            if ($button.hasClass('open')) {
                closeMenu();
            } else {
                openMenu();
            }
        });

        // Close menu when clicking the close button
        $('.menu-close').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            closeMenu();
        });

        // Close menu when clicking outside of it
        $(document).on('click', function(e) {
            if (!$(e.target).closest('.site-header__nav').length && !$(e.target).closest('.site-header__menu-toggle').length) {
                if ($('.nav-menu').hasClass('open')) {
                    closeMenu();
                }
            }
        });
    }, 100);

    function createCookie(name, value, days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
        }
        else var expires = "";               
    
        document.cookie = name + "=" + value + expires + "; path=/";
    }
    
    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    
    function eraseCookie(name) {
        createCookie(name, "", -1);
    }
});